import Input, { InputProps } from '@mui/material/Input';

export { Input, InputProps };
